import { Component, Input } from '@angular/core';

import { MonthStatusEnum } from '../../../enums';
import { IMonthlyEventData } from '../../../interfaces';

@Component({
    selector: 'app-events-activation-modal',
    templateUrl: './events-activation-modal.component.html',
    styleUrls: ['./events-activation-modal.component.scss'],
})
export class EventsActivationModalComponent {
    @Input() public selectedMonth: IMonthlyEventData;

    @Input() public eventsToDeactivate: string[];

    @Input() public eventsToActivate: string[];

    public monthlyEventsStatusEnum = MonthStatusEnum;
}
